// staying backward compatible
import { Adapter } from '@iobroker/js-controller-adapter';

export default Adapter;
